import { IntakeLabelCollection } from '../../entities/intake-label.interface';
export const AishPersonalInfoLabels: IntakeLabelCollection = {
  firstName: {
    label: 'First name',
  },
  preferredName: {
    label: 'Preferred name, if different',
  },
  middleName: {
    label: 'Middle name',
  },
  lastName: {
    label: 'Last name',
  },
  birthCertificateLastName: {
    label: 'Last name on birth certificate if different',
  },
  birthdate: {
    label: 'Birthdate',
  },
  gender: {
    label: 'Gender',
  },
  email: {
    label: 'Email address',
  },
  phoneNumber: {
    label: 'Phone number',
  },
  confirmEmail: {
    label: 'Confirm email address',
  },
  socialInsuranceNumber: {
    label: 'Social Insurance Number',
  },
  albertaHealthNumber: {
    label: 'Alberta Health Number',
  },
  noAlbertaHealthNumber: {
    label:
      'I do not have a Personal Health Number (PHN) / I am awaiting the arrival of my Personal Health Number (PHN) and I understand that not providing a Personal Health Number with my online application will cause delays and may result in my application being withdrawn.',
  },
  foreignNational: {
    label: 'Did you immigrate to Canada or are you a foreign national?',
  },
  immigrationStatus: {
    label: 'Citizenship / Immigration status',
  },
  sponsorshipStartDate: {
    label: 'Sponsorship Start Date',
  },
  sponsorshipEndDate: {
    label: 'Sponsorship End Date',
  },
  hasIndianRegistration: {
    label: 'Do you have an Indian Registration Number?',
    spousePartnerLabel: 'Does your <<spouseLabel>> have an Indian Registration Number?',
    thirdPersonLabel: 'Does <<personName>> have an Indian Registration Number?',
  },
  immigrationStatusOther: {
    label: 'Explain your immigration status',
  },
  livingSituation: {
    label: 'Living situation',
  },
  hasDifferentMailingAddress: {
    label: 'Is your mailing address different than your home address?',
    alternateLabel: 'Do you have a mailing address?',
  },
  hasMailingAddress: {
    label: 'Do you have a mailing address where you can be contacted?',
    thirdPersonLabel: 'Does <<applicantName>> have a mailing address where <<genderApplicantHeShe>> can be contacted?',
  },
  streetAddress: { label: 'Street address' },
  suiteNumber: { label: 'Suite or unit #' },
  city: { label: 'City/town' },
  province: { label: 'Province/territory' },
  postalCode: { label: 'Postal code' },
};
